import Vue from 'vue';

// https://github.com/ElementUI/theme-chalk
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import {
  Row,
  Col,
  Card,
  Link,
  Container,
  Header,
  Main,
  Button,
  Drawer,
  Menu,
  MenuItem,
  Avatar,
  Input,
  InputNumber,
  Form,
  FormItem,
  Alert,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Carousel,
  CarouselItem,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Message,
  MessageBox,
  Notification,
  Option,
  OptionGroup,
  Popover,
  Radio,
  RadioGroup,
  RadioButton,
  Select,
  Slider,
  Switch,
  Table,
  TableColumn,
  Tag,
  Timeline,
  TimelineItem,
  TimePicker,
  TimeSelect,
  Tooltip,
  Upload,
  Popconfirm,
} from 'element-ui';

import './element-theme-chalk/lib/index.css';
import './element-theme-chalk/lib/alert.css';
import './element-theme-chalk/lib/badge.css';
import './element-theme-chalk/lib/breadcrumb.css';
import './element-theme-chalk/lib/breadcrumb-item.css';
import './element-theme-chalk/lib/carousel.css';
import './element-theme-chalk/lib/carousel-item.css';
import './element-theme-chalk/lib/checkbox.css';
import './element-theme-chalk/lib/checkbox-group.css';
import './element-theme-chalk/lib/collapse.css';
import './element-theme-chalk/lib/collapse-item.css';
import './element-theme-chalk/lib/date-picker.css';
import './element-theme-chalk/lib/dialog.css';
import './element-theme-chalk/lib/dropdown.css';
import './element-theme-chalk/lib/dropdown-menu.css';
import './element-theme-chalk/lib/dropdown-item.css';
import './element-theme-chalk/lib/message.css';
import './element-theme-chalk/lib/message-box.css';
import './element-theme-chalk/lib/notification.css';
import './element-theme-chalk/lib/popover.css';
import './element-theme-chalk/lib/radio.css';
import './element-theme-chalk/lib/radio-group.css';
import './element-theme-chalk/lib/radio-button.css';
import './element-theme-chalk/lib/select.css';
import './element-theme-chalk/lib/switch.css';
import './element-theme-chalk/lib/table.css';
import './element-theme-chalk/lib/table-column.css';
import './element-theme-chalk/lib/tabs.css';
import './element-theme-chalk/lib/tag.css';
import './element-theme-chalk/lib/timeline.css';
import './element-theme-chalk/lib/timeline-item.css';
import './element-theme-chalk/lib/time-picker.css';
import './element-theme-chalk/lib/time-select.css';
import './element-theme-chalk/lib/tooltip.css';
import './element-theme-chalk/lib/upload.css';
import './element-theme-chalk/lib/icon.css';
import './element-theme-chalk/lib/loading.css';

locale.use(lang);

Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Card', Card);
Vue.component('Link', Link);
Vue.component('container', Container);
Vue.component('Header', Header);
Vue.component('Main', Main);
Vue.component('Button', Button);
Vue.component('Drawer', Drawer);
Vue.component('Menu', Menu);
Vue.component('menu-item', MenuItem);
Vue.component('Avatar', Avatar);
Vue.component('Input', Input);
Vue.component('InputNumber', InputNumber);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Alert', Alert);
Vue.component('Badge', Badge);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('ElTabs', Tabs);
Vue.component('Tab-pane', TabPane);
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Collapse', Collapse);
Vue.component('CollapseItem', CollapseItem);
Vue.component('DatePicker', DatePicker);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Message', Message);
Vue.component('MessageBox', MessageBox);
Vue.component('Notification', Notification);
Vue.component('Option', Option);
Vue.component('OptionGroup', OptionGroup);
Vue.component('Popover', Popover);
Vue.component('Radio', Radio);
Vue.component('RadioGroup', RadioGroup);
Vue.component('RadioButton', RadioButton);
Vue.component('Select', Select);
Vue.component('RangeSlider', Slider);
Vue.component('SwitchBtn', Switch);
Vue.component('Table', Table);
Vue.component('TableColumn', TableColumn);
Vue.component('Tag', Tag);
Vue.component('Timeline', Timeline);
Vue.component('TimelineItem', TimelineItem);
Vue.component('TimePicker', TimePicker);
Vue.component('TimeSelect', TimeSelect);
Vue.component('Tooltip', Tooltip);
Vue.component('Upload', Upload);
Vue.component('Popconfirm', Popconfirm);

const duration = (process.env.NODE_ENV === 'staging') ? 30000 : 3000;

Vue.prototype.$successMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'success',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Success'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$customMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'success',
    duration,
    message: h('div', null, [
      h('h3', null, null || 'Success'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$errorMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'error',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Error'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock toast-msg-mw',
  });
};

Vue.prototype.$infoMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'info',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Info'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$PromptConfirm = function $confirm(message = 'Default message', title = 'Default title', defaultOptions) {
  const options = {};
  options.confirmButtonText = defaultOptions.confirmButtonText || 'Ok';
  options.cancelButtonText = defaultOptions.cancelButtonText || 'Cancel';
  options.customClass = defaultOptions.customClass || '';
  options.cancelButtonClass = defaultOptions.cancelButtonClass || '';
  options.confirmButtonClass = defaultOptions.confirmButtonClass || '';
  if ('showCancelButton' in defaultOptions) {
    options.showCancelButton = defaultOptions.showCancelButton;
  }
  if ('showClose' in defaultOptions) {
    options.showClose = defaultOptions.showClose;
  }
  options.distinguishCancelAndClose = defaultOptions.distinguishCancelAndClose || false;
  options.closeOnClickModal = defaultOptions.closeOnClickModal || false;
  options.showInput = defaultOptions.showInput || false;
  return MessageBox.confirm(message, title, options);
};

Vue.prototype.$PromptAlert = function $alert(message = 'Default message', title = 'Default title', defaultOptions) {
  return MessageBox.alert(message, title, { dangerouslyUseHTMLString: true,
    showCancelButton: true,
    confirmButtonText: defaultOptions.confirmButtonText || 'Move',
    cancelButtonText: defaultOptions.cancelButtonText || 'Cancel' });
};

Vue.prototype.$successMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'success',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Success'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$infoMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'info',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Info'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock wp-20',
  });
};

Vue.prototype.$warningMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'warning',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Warning'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};
const boldRegex = /(<b[^>]+>|<b>|<\/b>)/g;
Vue.prototype.$success = function $notify({ message }) {
  const h = this.$createElement;
  return Message({
    type: 'success',
    duration,
    message: h('div', null, [
      h('h3', null, 'Success'),
      h('span', message.replace(boldRegex, '')),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};


Vue.prototype.$alert = function $notify({ message }) {
  const h = this.$createElement;
  return Message({
    type: 'info',
    duration,
    message: h('div', null, [
      h('h3', null, 'Alert'),
      h('span', message.replace(boldRegex, '')),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$error = function $notify({ message }) {
  const h = this.$createElement;
  return Message({
    type: 'error',
    duration,
    message: h('div', null, [
      h('h3', null, 'Error'),
      h('span', message.replace(boldRegex, '')),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$info = function $notify({ message }) {
  return Notification({
    type: 'info', message, duration, showClose: true, customClass: 'success', dangerouslyUseHTMLString: true,
  });
};
